import { TableCellProps, Td } from '@chakra-ui/table';
import React from 'react';

export const CmTd: React.FC<TableCellProps> = ({ ...rest }) => {
  // @ts-ignore TS2590
  return <Td padding="10px" {...rest} />;
};
